/**
 * An implementation of the Visitor design pattern for Chart of
 * Accounts groups.
 */
export default class AbstractAccountGroupVisitor {
	visitAbstractAccountGroup(_accountGroup) {}

	visitAccountGroupAliasing(accountGroupAliasing) {
		return this.visitAbstractAccountGroup(accountGroupAliasing);
	}

	visitAccountGroup(accountGroup) {
		return this.visitAbstractAccountGroup(accountGroup);
	}

	visitAccountListGroup(accountListGroup) {
		return this.visitAbstractAccountGroup(accountListGroup);
	}

	visitIntervalAccountGroup(intervalAccountGroup) {
		return this.visitAbstractAccountGroup(intervalAccountGroup);
	}

	visitUndefinedAccountGroup(undefinedAccountGroup) {
		return this.visitAccountGroup(undefinedAccountGroup);
	}
}
